import { Component, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { OlimpiaService } from '../../services/olimpia.service';
import { WhatsappSessionService } from '../../services/whatsapp-session.service';
import { ErrorScreenComponent } from 'app/shared/error-screen/error-screen.component';
import { WowComponent } from 'app/shared/wow/wow.component';
import { LoaderService } from 'app/services/loader.service';

@Component({
  selector: 'app-whatsapp-validation',
  standalone: true,
  imports: [CommonModule,
            ErrorScreenComponent,
            WowComponent],
  templateUrl: './whatsapp-validation.component.html',
  styleUrl: './whatsapp-validation.component.css'
})
export class WhatsappValidationComponent implements OnInit, OnDestroy {

  hash = '';

  showOlimpia = signal(false);
  wowDisplay = signal(false);
  showError = signal(false);
  reload = signal(false);

  validationOlimpiaUrl: SafeResourceUrl | null = null;
  processGuid = '';
  intervalId: any;
  titleError: string = '';
  descriptionError: string = '';

  constructor(
    private route: ActivatedRoute,
    private olimpiaService: OlimpiaService,
    private whatsappSessionService: WhatsappSessionService,
    private sanitizer: DomSanitizer,
    private _loaderService: LoaderService,
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.hash = params.get('hash') ?? '';
      if (this.hash) {
        this.verifyWhatsappSession();
      }
    });
  }

  private verifyWhatsappSession(): void {
    this.whatsappSessionService.verifySessionWhatsapp(this.hash).subscribe({
      next: (response: any) => {
        localStorage.setItem('session', response.session);
        this.startOlimpia();
      },
      error: (error) => {
        console.error(error);
        this.failMessage('Sesión inválida o expirada', 'Sesión inválida');
      }
    });
  }

  private startOlimpia(): void {
    this._loaderService.show('Iniciando validación...');

    this.olimpiaService.getWhatsappValidation().subscribe({
      next: (response: any) => {
        const data = response.data;
        this.processGuid = data.procesoConvenioGuid;
        this.validationOlimpiaUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(data.url);

        this._loaderService.hide();
        this.showOlimpia.set(true);
        this.startInterval();
      },
      error: (error) => {
        console.error(error);
        this.failMessage('No fue posible iniciar la validación');
      }
    });
  }

  private startInterval(): void {
    setTimeout(() => {
      this.intervalId = setInterval(() => {
        this.olimpiaService.verifyValidation(this.processGuid).subscribe({
          next: (response: any) => {
            const { data, barcodeData } = response;

            if (data.finalizado || data.cancelado) {
              this.closeModal();

              if (data.aprobado) {
                this.validateOlimpia(barcodeData);
              } else {
                this.failMessage('116: Autenticación incorrecta, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...');
              }
            }
          },
          error: (error) => console.error(error)
        });
      }, 10000);
    }, 60000);
  }

  private validateOlimpia(barcodeData: any): void {
    this.olimpiaService.setValidate(barcodeData).subscribe({
      next: () => this.showWow(),
      error: () =>this.failMessage('106-E: Ha fallado la validación del usuario, intente de nuevo, acérquese a una oficina o comuníquese con su asesor...')
    });
  }

  closeModal(): void {
    this.showOlimpia.set(false);
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  failMessage(description:string, title:string = 'Error') {
    this.titleError = title;
    this.descriptionError = description;
    this.showError.set(true);
    this._loaderService.hide();
  }

  showWow(): void {
    this.wowDisplay.set(true);
    this._loaderService.hide();
    setTimeout(() => {
      this.next();
    }, 10000);
  }

  next(): void {
    const phoneNumber = '573203495145';
    const message = encodeURIComponent('Ya validé mi identidad.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  }

  retry(): void {
    this.showError.set(false);
    this.titleError= '';
    this.descriptionError= '';
    this.startOlimpia();
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
